import { jsx as _jsx } from "react/jsx-runtime";
const Checkmark = props => (_jsx("svg", { width: "10", height: "8", viewBox: "0 0 10 8", xmlns: "http://www.w3.org/2000/svg", ...props, children: _jsx("path", { d: "M3.4 5.6L8.9.1c.1-.1.2-.1.4 0l.7.7c.1.1.1.3 0 .4L3.6 7.5c-.1.1-.3.1-.4 0l-3.1-3c-.1-.1-.1-.3 0-.4l.7-.7c.1-.1.3-.1.4 0l2.2 2.2z" }) }));
export default Checkmark;
